<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-role-card">
        <div class="sl-role-card__title">
            {{ $t('role.MANAGER_WITHOUT_PRICES.label') }}
        </div>
        <p class="sl-role-card__permission-list">
            {{ $t('user_management.role_card.prefix') }}
        </p>
        <ul>
            <li class="sl-role-card__permission-list-item">
                {{ $t('user_management.role_card.permissions.place_orders') }}
            </li>
            <li class="sl-role-card__permission-list-item">
                {{ $t('user_management.role_card.permissions.make_returns') }}
            </li>
            <li class="sl-role-card__permission-list-item">
                {{ $t('user_management.role_card.permissions.edit_company_informations') }}
            </li>
            <li class="sl-role-card__permission-list-item">
                {{ $t('user_management.role_card.permissions.manage_company_users') }}
            </li>
        </ul>
    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ManagerWithoutPrices',
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>

</style>
